<div class="h-screen p-8 flex items-center justify-center">
  <div class="flex items-center flex-col flex-wrap justify-center gap-6">
    <div class="w-2/4 lg:w-1/4">
      <img alt="Server Error Image" src="../../../../assets/images/server-error.jpg"/>
    </div>
  <div class="flex justify-center items-center flex-col gap-6">
    <h1 class="font-bold text-2xl">Oops! Something went wrong on our end.</h1>
    <div class="bg-red-600 h-1 rounded-lg w-32"></div>
    <p>We’re working on it and will get things back to normal soon.</p>
    <p class="text-gray-500">Please try again later.</p>
    <full-button (click)="navigateToDashboard()" text="Try again"/>
  </div>
  </div>
</div>
